import { useDispatch } from "react-redux";
import { FormRegion } from "../../../../components/formregion";
import { Field } from "@progress/kendo-react-form";
import {
  FormDropDownListById,
  FormInput,
} from "../../../../forms/form-components";
import {
  databaseDDL,
  setFormValue,
} from "../../../../redux/slices/createdatasetpageslice";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const CreateFromDbStep = (props) => {
  //#region state
  const { formValues } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  //#endregion

  //#region functions
  const handleOnChangeField = (id, value) => {
    dispatch(setFormValue({ id, value }));
  };
  //#endregion
  return (
    <FormRegion>
      <div className="form-group form-group-1" style={{ marginBottom: "50px" }}>
        <Field
          id={"DatabaseType"}
          name={"DatabaseType"}
          label={t("datasets.create.datatype")}
          component={FormDropDownListById}
          data={databaseDDL}
          dataItemKey="Id"
          textField="Title"
          onChange={(e) => handleOnChangeField("DatabaseType", e.value)}
        />
        <Field
          id={"Server"}
          name={"Server"}
          label={t("datasets.create.server")}
          component={FormInput}
          type={"text"}
          onChange={(e) => handleOnChangeField("Server", e.value)}
        />
        <Field
          id={"Database"}
          name={"Database"}
          label={t("datasets.create.database")}
          component={FormInput}
          type={"text"}
          onChange={(e) => handleOnChangeField("Database", e.value)}
        />
        <Field
          id={"Username"}
          name={"Username"}
          label={t("datasets.create.username")}
          component={FormInput}
          type={"text"}
          onChange={(e) => handleOnChangeField("Username", e.value)}
        />
        <Field
          id={"Password"}
          name={"Password"}
          label={t("datasets.create.password")}
          component={FormInput}
          type={"password"}
          onChange={(e) => handleOnChangeField("Password", e.value)}
        />
      </div>
    </FormRegion>
  );
};

export default CreateFromDbStep;
